/**
 * Gives the sticky site header a solid background while the visitor is
 * scrolling back up the page.
 *
 * The header is position: sticky and transparent, so on the way down the
 * titles sit over whatever content is passing underneath and become hard to
 * read. Scrolling up is when someone is looking for the navigation, so that is
 * when the background appears. At the very top of the page it always goes back
 * to transparent, so the hero is never covered by a band.
 *
 * Sets data-solid="true|false" on the header; the styling lives in
 * conversion-updates.css.
 */
(function () {
  var header = document.querySelector('header.section-header');
  if (!header) return;

  var lastY = window.scrollY;
  var ticking = false;
  var JITTER = 6; // ignore trackpad noise and rubber-banding

  var BREATHING_ROOM = 24; // px below the navigation row

  function headerHeight() {
    var content = header.querySelector('.site-header__content');
    return content ? content.getBoundingClientRect().height : 160;
  }

  /**
   * The band stops just under the navigation row rather than covering the whole
   * header block. Measured rather than hard-coded, because the row sits at a
   * different height once the logo shrinks and on narrower screens. Falls back
   * to the full header height where the row is not rendered at all, as on a
   * phone.
   */
  function syncBandHeight() {
    var nav = header.querySelector('.site-navigation');
    var navBox = nav && nav.getBoundingClientRect();
    var height;

    if (navBox && navBox.height) {
      height = navBox.bottom - header.getBoundingClientRect().top + BREATHING_ROOM;
    } else {
      height = headerHeight();
    }

    if (height > 0) {
      header.style.setProperty('--site-header__band-height', Math.round(height) + 'px');
    }
  }

  function setSolid(on) {
    header.setAttribute('data-solid', on ? 'true' : 'false');
  }

  function update() {
    ticking = false;
    syncBandHeight();
    var y = window.scrollY;

    // Back at the top: always transparent over the hero.
    if (y <= 4) {
      setSolid(false);
      lastY = y;
      return;
    }

    var delta = y - lastY;
    // Leave lastY alone below the threshold so slow scrolls still accumulate.
    if (Math.abs(delta) < JITTER) return;

    setSolid(delta < 0 && y > headerHeight());
    lastY = y;
  }

  window.addEventListener('resize', syncBandHeight);

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });

  // requestAnimationFrame is paused while the tab is hidden, which would leave
  // ticking stuck true and the listener dead once the visitor comes back.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      ticking = false;
      lastY = window.scrollY;
      update();
    }
  });

  syncBandHeight();
  update();
})();
